@if (!hasInner()) {
  <a
    class="group flex items-center gap-12 hover:bg-primary-950 hover:text-secondary-50 h-40 px-12 rounded-lg relative cursor-pointer"
    tabindex="0"
    role="menuitem"
    [class.bg-primary-900]="linkActive()"
    [class.text-secondary-50]="linkActive()"
    [class.text-secondary-200]="!linkActive()"
    [routerLink]="link().link"
    [fcTooltip]="isCollapsed() ? link().name : ''"
    [offset]="16"
    [position]="'right'"
    (click)="onClick.emit()"
  >
    <fc-icon
      [ngClass]="{
        'bg-secondary-50!': linkActive(),
      }"
      class="bg-secondary-300 group-hover:bg-secondary-50!"
      [icon]="activeIcon()"
      [size]="24"
    />

    @if (!isCollapsed()) {
      <span class="text-base leading-[24px] text-start text-nowrap">
        {{ link().name }}
      </span>
    }

    @if (link().beta && !isCollapsed()) {
      <div
        class="px-8 py-4 outline group-hover:outline-secondary-50 rounded-md group-hover:text-secondary-50 text-xs mr-auto"
        [class.outline-secondary-50]="linkActive()"
        [class.outline-secondary-300]="!linkActive()"
        [class.text-secondary-50]="linkActive()"
        [class.text-secondary-300]="!linkActive()"
      >
        Beta
      </div>
    }

    @if (link().notification && link().notification > 0) {
      <div
        class="ml-auto z-10 flex items-center justify-center rounded-full bg-secondary-50 text-primary-1000 text-xs font-medium"
        [ngClass]="{
          'absolute -right-4 -top-4': isCollapsed(),
          'size-16': link().notification < 99,
          'h-16 min-w-16 px-4': link().notification >= 99,
        }"
      >
        {{ link().notification < 99 ? link().notification : '99+' }}
      </div>
    }
  </a>
}

@if (hasInner()) {
  @if (isCollapsed()) {
    <button
      #navTrigger
      type="button"
      fcOverlayHover
      [closeDelay]="140"
      class="group flex items-center gap-12 hover:bg-primary-950 hover:text-secondary-50 h-40 px-12 rounded-lg relative transition-colors duration-150 ease-in-out cursor-pointer"
      tabindex="0"
      role="menuitem"
      [class.bg-primary-900]="parentActive()"
      [class.text-secondary-50]="linkActive()"
      [class.text-secondary-200]="!linkActive()"
      (click)="handleParentClick($event)"
    >
      <fc-icon
        [ngClass]="{
          'bg-secondary-50!': linkActive(),
        }"
        class="bg-secondary-300 group-hover:bg-secondary-50!"
        [icon]="parentActiveIcon()"
        [size]="24"
      />

      @if (link().notification && link().notification > 0) {
        <div
          class="absolute -right-4 -top-4 flex items-center justify-center rounded-full bg-secondary-50 text-primary-1000 text-xs font-medium"
          [ngClass]="{
            'size-16': link().notification < 99,
            'h-16 min-w-16 px-4': link().notification >= 99,
          }"
        >
          {{ link().notification < 99 ? link().notification : '99+' }}
        </div>
      }

      <fc-icon
        [icon]="'icon-arrow-right'"
        [ngClass]="{
          'bg-secondary-50!': linkActive(),
        }"
        class="transition-transform duration-200 ease-in-out absolute left-32 bg-secondary-300 group-hover:bg-secondary-50!"
        [size]="20"
      />
    </button>

    <div [fcOverlay]="navTrigger" [position]="'right'" role="menu">
      <fc-navigation-popover
        [context]="{ title: link().name, children: link().inner }"
        (click)="onClick.emit()"
      />
    </div>
  } @else {
    <button
      type="button"
      class="group flex items-center gap-12 hover:bg-primary-950 hover:text-secondary-50 h-40 px-12 rounded-lg relative transition-colors duration-150 ease-in-out cursor-pointer"
      tabindex="0"
      role="menuitem"
      [class.bg-primary-900]="parentActive()"
      [class.text-secondary-50]="linkActive()"
      [class.text-secondary-200]="!linkActive()"
      (click)="handleParentClick($event)"
    >
      <fc-icon
        [ngClass]="{
          'bg-secondary-50!': linkActive(),
        }"
        class="bg-secondary-300 group-hover:bg-secondary-50!"
        [icon]="parentActiveIcon()"
        [size]="24"
      />

      <span class="text-base leading-[24px] text-start text-nowrap">
        {{ link().name }}
      </span>

      @if (link().beta) {
        <div
          class="px-8 py-4 outline group-hover:outline-secondary-50 rounded-md group-hover:text-secondary-50 text-xs mr-auto"
          [class.outline-secondary-50]="linkActive()"
          [class.outline-secondary-300]="!linkActive()"
          [class.text-secondary-50]="linkActive()"
          [class.text-secondary-300]="!linkActive()"
        >
          Beta
        </div>
      }

      @if (link().notification && link().notification > 0) {
        <div
          class="ml-auto flex items-center justify-center rounded-full bg-secondary-50 text-primary-1000 text-xs font-medium"
          [ngClass]="{
            'size-16': link().notification < 99,
            'h-16 min-w-16 px-4': link().notification >= 99,
          }"
        >
          {{ link().notification < 99 ? link().notification : '99+' }}
        </div>
      }

      <fc-icon
        [icon]="'icon-arrow-drop-down'"
        [ngClass]="{
          'bg-secondary-50!': linkActive(),
        }"
        class="transition-transform duration-200 ease-in-out ml-auto bg-secondary-300 group-hover:bg-secondary-50!"
        [class.rotate-180]="link().open"
        [size]="24"
      />
    </button>
  }

  <div
    class="grid ml-20 pl-12 border-l-1 border-primary-900 overflow-hidden transition-all duration-200 ease-in-out"
    [style.grid-template-rows]="link().open && !isCollapsed() ? '1fr' : '0fr'"
    [class.mt-4]="link().open && !isCollapsed()"
  >
    <div class="min-h-0 flex flex-col gap-4">
      @for (child of link().inner; track $index) {
        <fc-navigation-children [child]="child" (click)="onClick.emit()" />
      }
    </div>
  </div>
}
